import { comprehensiveGlossaryLinks } from "@/lib/maritimeGlossaryData";
import { getRegulationsHubTranslation, getRegulationsLabels } from "@/lib/regulationTranslations";
import { localizedRoutes } from "@/lib/i18nRoutes";

const heGlossaryTerms = {
  abeam: ["לצד הסירה", "כיוון בזווית ישרה לקו האמצע של כלי השיט, ישירות מצד שמאל או ימין."],
  abaft: ["מאחור", "לכיוון הירכתיים או מאחורי נקודת ייחוס בכלי השיט."],
  aft: ["ירכתיים", "לכיוון החלק האחורי של הסירה."],
  amidships: ["מרכז הסירה", "החלק האמצעי של כלי השיט, בין החרטום לירכתיים."],
  anchor: ["עוגן", "אביזר כבד המשמש להחזקת כלי שיט במקום באמצעות אחיזה בקרקעית הים."],
  anchorage: ["מעגן", "אזור מתאים שבו כלי שיט יכולים לעגון בבטחה."],
  "apparent-wind": ["רוח מדומה", "הרוח שמורגשת על הסיפון, שילוב של הרוח האמיתית ותנועת הסירה."],
  astern: ["מאחורי הסירה", "מאחורי כלי השיט או תנועה לאחור."],
  athwartships: ["לרוחב הסירה", "מצד לצד לרוחב כלי השיט."],
  backstay: ["מיתר אחורי", "כבל תמיכה מהמַסְט לכיוון הירכתיים התומך במערך המפרשים."],
  ballast: ["נטל", "משקל נמוך בכלי השיט המשפר יציבות."],
  barometer: ["ברומטר", "מכשיר למדידת לחץ אטמוספרי לצורך חיזוי מזג אוויר."],
  beam: ["רוחב מרבי", "החלק הרחב ביותר בכלי השיט."],
  "beam-reach": ["הפלגה ברוח צד", "מצב הפלגה שבו הרוח מגיעה בערך ב־90 מעלות לכיוון הסירה."],
  bearing: ["תכווין", "הכיוון מנקודה אחת לאחרת, לרוב נמדד במעלות."],
  berth: ["מקום עגינה", "מקום שבו כלי שיט נקשר או מקום שינה על הסיפון."],
  bilge: ["שיפוליים", "החלק הפנימי הנמוך ביותר בסירה שבו עלולים להצטבר מים."],
  "bitter-end": ["קצה חבל", "הקצה האחרון של חבל, מיתר או שרשרת עוגן."],
  boom: ["מנור", "קורה אופקית המחוברת לתורן ושולטת בבסיס המפרש."],
  bow: ["חרטום", "החלק הקדמי של כלי השיט."],
  bowsprit: ["חרטומית", "מוט הבולט קדימה מהחרטום לתמיכת מפרשי חרטום."],
  "broad-reach": ["הפלגה ברוח גבית-צד", "מצב הפלגה שבו הרוח מגיעה מאחורי הקורה."],
  buoy: ["מצוף", "סמן ניווט צף או אמצעי עגינה."],
  cabin: ["תא", "חלל מגורים או עבודה סגור על הסיפון."],
  capsize: ["התהפכות", "מצב שבו כלי שיט מתהפך במים."],
  chartplotter: ["פלוטר מפות", "תצוגת ניווט אלקטרונית המציגה מפות ומיקום כלי השיט."],
  cleat: ["זקף קשירה", "אביזר המשמש לאבטחת חבלים על הסיפון או בחוף."],
  "close-hauled": ["הפלגה קרובה לרוח", "הפלגה קרוב ככל האפשר לכיוון הרוח בצורה יעילה."],
  "close-reach": ["רוח קדמית-צד", "מצב הפלגה בין קרוב לרוח לבין רוח צד."],
  cockpit: ["קוקפיט", "האזור שבו ההגה והצוות מפעילים את כלי השיט."],
  colregs: ["תקנות COLREGs", "התקנות הבינלאומיות למניעת התנגשויות בים."],
  compass: ["מצפן", "מכשיר ניווט המציג כיוון ביחס לצפון המגנטי."],
  "course-over-ground": ["קורס על פני הקרקע", "הכיוון בפועל שבו כלי השיט נע על פני כדור הארץ."],
  "dead-reckoning": ["ניווט מקורב", "הערכת מיקום באמצעות קורס, מהירות, זמן ומיקום קודם."],
  deck: ["סיפון", "משטח העבודה האופקי של כלי השיט."],
  dinghy: ["סירת שירות", "סירה קטנה המשמשת לעיתים כסירת עזר לכלי שיט גדול יותר."],
  displacement: ["דחי", "משקל המים שכלי השיט דוחק, הקשור למשקל הסירה."],
  draft: ["שוקע", "עומק המים הדרוש לכלי השיט לצוף בבטחה."],
  fairlead: ["מוביל חבל", "אביזר המכוון חבל ומפחית שחיקה."],
  fathom: ["פתום", "יחידת עומק ימית השווה לשישה רגל."],
  fender: ["פנדר", "כרית הגנה בין כלי שיט לרציף או לכלי שיט אחר."],
  flare: ["נור מצוקה", "אות מצוקה חזותי המשמש במקרי חירום."],
  foredeck: ["סיפון קדמי", "אזור הסיפון הקדמי ליד החרטום."],
  forestay: ["מיתר קדמי", "כבל תמיכה מהתורן לחרטום התומך בתורן ובמפרש קדמי."],
  freeboard: ["גובה דופן", "המרחק האנכי מקו המים עד שפת הסיפון."],
  galley: ["מטבחון", "אזור המטבח בכלי השיט."],
  genoa: ["ג׳נואה", "מפרש קדמי גדול וחופף המשמש ביאכטות מפרש."],
  gimbals: ["גימבלים", "תושבות מסתובבות השומרות ציוד מאוזן כשהסירה נוטה."],
  gooseneck: ["חיבור מנור", "האביזר המחבר את המנור לתורן."],
  "ground-tackle": ["ציוד עגינה", "ציוד העגינה הכולל עוגן, שרשרת, חבל ואביזרים."],
  gunwale: ["שפת דופן", "השפה העליונה של צד הסירה."],
  halyard: ["מעלן", "חבל המשמש להעלאה או הורדה של מפרשים ודגלים."],
  harbor: ["נמל מוגן", "אזור מים מוגן שבו כלי שיט יכולים להיקשר או לעגון."],
  hatch: ["פתח סיפון", "פתח בסיפון או בתא לצורך גישה, אור או אוורור."],
  head: ["שירותים ימיים", "תא שירותים או חדר רחצה בכלי שיט."],
  heading: ["כיוון חרטום", "הכיוון שאליו החרטום מצביע."],
  headsail: ["מפרש קדמי", "מפרש המותקן לפני התורן, כמו חלוץ או ג׳נואה."],
  "heave-to": ["עצירת סערה", "תמרון האטה שבו מפרשים והגה מאזנים את הסירה."],
  heel: ["הטיה", "נטיית כלי שיט מפרשי תחת לחץ הרוח."],
  helm: ["הגה", "עמדת ההיגוי או אמצעי השליטה בכיוון כלי השיט."],
  hull: ["גוף הסירה", "הגוף המרכזי של כלי השיט."],
  jib: ["חלוץ", "מפרש קדמי משולש המותקן לפני התורן."],
  jibe: ["מהפך", "שינוי מפנה כאשר הירכתיים עוברות דרך הרוח."],
  keel: ["קיל", "סנפיר או שדרה מתחת לגוף הסירה המספקים יציבות וכיוון."],
  knot: ["קשר", "יחידת מהירות ימית השווה למייל ימי לשעה."],
  latitude: ["קו רוחב", "קואורדינטה גאוגרפית למדידת מרחק מצפון או מדרום לקו המשווה."],
  leeway: ["סחיפה צדית", "סחיפה הצידה הנגרמת מרוח או זרם."],
  leeward: ["צד מוגן מהרוח", "הצד המוסתר או המוגן מהרוח."],
  lifeline: ["מעקה בטיחות", "כבל או מעקה בטיחות סביב סיפון כלי השיט."],
  logbook: ["יומן הפלגה", "רישום פרטי הפלגה, ניווט, מזג אוויר ואירועים."],
  longitude: ["קו אורך", "קואורדינטה גאוגרפית למדידת מרחק ממזרח או ממערב לגריניץ׳."],
  mainsail: ["מפרש ראשי", "המפרש המרכזי המותקן על התורן הראשי."],
  marina: ["מרינה", "מתקן המספק מקומות עגינה ושירותים לסירות."],
  mast: ["תורן", "מוט אנכי התומך במפרשים ובחיבל."],
  mayday: ["מיידיי", "קריאת המצוקה הבינלאומית לסכנה חמורה ומיידית."],
  mooring: ["קשירה", "מערכת או מקום קבוע לאבטחת כלי שיט."],
  "nautical-mile": ["מייל ימי", "יחידת מרחק ימית השווה לדקת קו רוחב אחת."],
  port: ["דופן שמאל", "הצד השמאלי של כלי השיט כשמביטים קדימה."],
  reef: ["צמצום מפרש", "הקטנת שטח מפרש לרוחות חזקות או לשליטה בטוחה יותר."],
  rigging: ["חיבל", "כבלים, חבלים ואביזרים התומכים ושולטים במפרשים."],
  rudder: ["הגה כיוון", "משטח תת-מימי המשמש להיגוי כלי השיט."],
  "sail-trim": ["כיוון מפרשים", "התאמת המפרשים לכוח, איזון ושליטה יעילים."],
  "sea-state": ["מצב ים", "מצב פני הים לפי גלים ונחשול."],
  sheet: ["מיתר שליטה", "חבל המשמש לשליטה בזווית המפרש."],
  skipper: ["סקיפר", "האדם האחראי לפיקוד ולבטיחות כלי השיט."],
  spinnaker: ["ספינקר", "מפרש גדול לרוח גבית."],
  starboard: ["דופן ימין", "הצד הימני של כלי השיט כשמביטים קדימה."],
  stern: ["ירכתיים", "החלק האחורי של כלי השיט."],
  tack: ["סיבוב מול הרוח", "שינוי כיוון כאשר החרטום עובר דרך הרוח, או פינת המפרש הקדמית התחתונה."],
  tide: ["גאות ושפל", "עלייה וירידה מחזורית של פני הים הנגרמת בעיקר מכבידת הירח והשמש."],
  "true-wind": ["רוח אמיתית", "כיוון ומהירות הרוח בפועל ביחס לפני כדור הארץ."],
  "vhf-channel": ["ערוץ VHF", "ערוץ רדיו ימי לתקשורת ולבטיחות בין כלי שיט."],
  wake: ["שובל", "המים המופרעים שנותרים מאחורי כלי שיט בתנועה."],
  waypoint: ["נקודת ציון", "מיקום ניווט מוגדר המשמש לתכנון מסלול."],
  windward: ["מול הרוח", "הצד הפונה אל הרוח או לכיוונה."],
  yaw: ["סטיית חרטום", "סיבוב צד-לצד של כלי השיט סביב הציר האנכי שלו."],
};

const defaultSeoHubLabels = {
  en: { home: "Home", glossaryBreadcrumb: "Glossary", regulationsBreadcrumb: "Regulations", featuredTitle: "Featured Public Pages", faqTitle: "Frequently asked questions", premiumTools: "View Premium Tools" },
  he: { home: "בית", glossaryBreadcrumb: "מילון ימי", regulationsBreadcrumb: "תקנות", featuredTitle: "עמודים ציבוריים מומלצים", faqTitle: "שאלות נפוצות", premiumTools: "צפו בכלי פרימיום" },
  es: { home: "Inicio", glossaryBreadcrumb: "Glosario", regulationsBreadcrumb: "Reglamentos", featuredTitle: "Páginas públicas destacadas", faqTitle: "Preguntas frecuentes", premiumTools: "Ver herramientas premium" },
  it: { home: "Home", glossaryBreadcrumb: "Glossario", regulationsBreadcrumb: "Regolamenti", featuredTitle: "Pagine pubbliche in evidenza", faqTitle: "Domande frequenti", premiumTools: "Vedi strumenti premium" },
  fr: { home: "Accueil", glossaryBreadcrumb: "Glossaire", regulationsBreadcrumb: "Réglementations", featuredTitle: "Pages publiques en vedette", faqTitle: "Questions fréquentes", premiumTools: "Voir les outils premium" },
  de: { home: "Startseite", glossaryBreadcrumb: "Glossar", regulationsBreadcrumb: "Vorschriften", featuredTitle: "Ausgewählte öffentliche Seiten", faqTitle: "Häufig gestellte Fragen", premiumTools: "Premium-Tools ansehen" },
  pt: { home: "Início", glossaryBreadcrumb: "Glossário", regulationsBreadcrumb: "Regulamentos", featuredTitle: "Páginas públicas em destaque", faqTitle: "Perguntas frequentes", premiumTools: "Ver ferramentas premium" },
  ar: { home: "الرئيسية", glossaryBreadcrumb: "المعجم", regulationsBreadcrumb: "اللوائح", featuredTitle: "صفحات عامة مميزة", faqTitle: "الأسئلة الشائعة", premiumTools: "عرض الأدوات المميزة" },
  el: { home: "Αρχική", glossaryBreadcrumb: "Γλωσσάρι", regulationsBreadcrumb: "Κανονισμοί", featuredTitle: "Προτεινόμενες δημόσιες σελίδες", faqTitle: "Συχνές ερωτήσεις", premiumTools: "Προβολή premium εργαλείων" },
  ru: { home: "Главная", glossaryBreadcrumb: "Глоссарий", regulationsBreadcrumb: "Правила", featuredTitle: "Рекомендуемые публичные страницы", faqTitle: "Частые вопросы", premiumTools: "Посмотреть premium-инструменты" },
  tr: { home: "Ana sayfa", glossaryBreadcrumb: "Sözlük", regulationsBreadcrumb: "Mevzuat", featuredTitle: "Öne çıkan herkese açık sayfalar", faqTitle: "Sık sorulan sorular", premiumTools: "Premium araçları görüntüle" },
  zh: { home: "首页", glossaryBreadcrumb: "术语表", regulationsBreadcrumb: "法规", featuredTitle: "精选公开页面", faqTitle: "常见问题", premiumTools: "查看高级工具" },
};

function getDefaultSeoHubLabels(type, lang = "en") {
  const labels = defaultSeoHubLabels[lang] || defaultSeoHubLabels.en;
  return {
    home: labels.home,
    breadcrumb: type === "glossary" ? labels.glossaryBreadcrumb : labels.regulationsBreadcrumb,
    featuredTitle: labels.featuredTitle,
    faqTitle: labels.faqTitle,
    premiumTools: labels.premiumTools,
  };
}

const translations = {
  glossary: {
    he: {
      eyebrow: "מילון ימי",
      title: "למדו מונחים ימיים, שפת ימאות ומושגי ניווט",
      description: "מילון ימי ציבורי לשייטים, תלמידים, סקיפרים ואנשי מקצוע שרוצים להבין את שפת הים בעברית פשוטה וברורה.",
      cta: "עיינו במילון",
      sections: [
        {
          title: "קטגוריות במילון",
          items: [
            "מונחי ניווט",
            "תמרוני מפרש",
            "מונחי מזג אוויר",
            "שפת בטיחות וחירום",
            "מונחי מרינה ועגינה",
            "מונחי תקנות וצ׳רטר",
          ],
        },
        {
          title: "ערך לימודי",
          items: [
            "הגדרות ברורות למתחילים",
            "קישורים פנימיים לשיעורים",
            "דוגמאות שימושיות מהסיפון",
            "בסיס להרחבה רב־לשונית",
            "שימושי ללימוד ימאות",
            "תומך במסלולי למידה מובנים",
          ],
        },
      ],
      faqs: [
        { question: "למי מיועד המילון הימי?", answer: "המילון מיועד לשייטים מתחילים, תלמידי סקיפר, אורחי צ׳רטר ואנשי מקצוע שרוצים הגדרות ימיות מהירות וברורות." },
        { question: "האם מונחי המילון מקושרים לשיעורים?", answer: "כן. מונחי המילון נועדו להתחבר באופן טבעי למאמרי לימוד, תקנות ותוכן לתכנון הפלגות." },
        { question: "איך מתחילים להשתמש במילון הימי?", answer: "כדאי להתחיל במונחי ניווט, עגינה, מזג אוויר ובטיחות נפוצים, ואז להמשיך לעמודי הלמידה הקשורים." },
        { question: "האם ההגדרות מתאימות להפלגות אמיתיות?", answer: "הן מיועדות ללמידה ולהבנה. החלטות תפעוליות יש לאמת עם מפות רשמיות, תקנות מקומיות, מדריכים ופרסומים ימיים עדכניים." },
        { question: "האם המילון כולל מונחי חירום ובטיחות?", answer: "כן. שפת בטיחות כמו קריאות מצוקה, מונחי VHF, אותות חירום ומושגי תגובה בסיסיים היא חלק ממבנה המילון." },
        { question: "אפשר להשתמש במילון לפני קורס שייט?", answer: "כן. המילון עוזר ללמוד אוצר מילים ימי לפני שיעורים, אימון מעשי, תדריך צ׳רטר או מבחני סקיפר." },
        { question: "האם יתווספו מונחים נוספים בהמשך?", answer: "כן. המילון בנוי להתרחב עם הגדרות, דוגמאות, שיעורים קשורים ואוצר מילים ימי רב־לשוני." },
      ],
      labels: {
        home: "בית",
        breadcrumb: "מילון ימי",
        featuredTitle: "מונחים ימיים נפוצים",
        faqTitle: "שאלות נפוצות",
        premiumTools: "כלי פרימיום",
      },
    },
  },
};

export function getLocalizedSeoHub(type, lang, hub) {
  if (type === "regulations") return getRegulationsHubTranslation(lang, hub);

  const localized = translations[type]?.[lang];
  if (!localized) return hub;

  return {
    ...hub,
    ...localized,
    heroImage: hub.heroImage,
    schemaType: hub.schemaType,
    featuredPages: type === "glossary" ? getLocalizedGlossaryLinks(lang) : hub.featuredPages,
    related: hub.related,
  };
}

export function getLocalizedGlossaryLinks(lang = "en") {
  const glossaryBase = localizedRoutes.glossary?.[lang] || localizedRoutes.glossary.en || "glossary";

  return comprehensiveGlossaryLinks.map((term) => {
    const slug = term.href.split("/").pop();
    const translated = lang === "he" ? heGlossaryTerms[slug] : null;
    return {
      ...term,
      href: `/${lang}/${glossaryBase}/${slug}`,
      label: translated?.[0] || term.label,
      description: translated?.[1] || term.description,
    };
  });
}

export function getSeoHubLabels(type, lang = "en") {
  if (type === "regulations") {
    const labels = getRegulationsLabels(lang);
    if (labels) return labels;
  }

  return translations[type]?.[lang]?.labels || getDefaultSeoHubLabels(type, lang);
}